<template>
  <v-dialog v-model="model" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon tile @click="model = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>调车计划 - {{ date }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn tile text @click="model = false"> 关闭 </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
          </a-table>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "DispatchResult",
  data() {
    return {
      date: "",
      model: false,
      list: [],
      headers: [
        {
          title: "车辆归属", dataIndex: 'own_type', align: 'center', scopedSlots: { customRender: 'own_type' }, customRender: (value, row) => {
            const obj = {
              children: row.own_type === '自有车' ? <div>
                <p>{value}</p>
                <p>(<span style="color:green;">{row.count1}头</span><span style="color:red;">{row.count2}挂</span>)</p>
                <p style="color:red;">{row.rowSpan1}趟</p>
              </div> : <div>
                <p>{value}</p>
                <p>(<span style="color:green;">{row.count1}车</span>)</p>
                <p style="color:red;">{row.rowSpan1}趟</p>
              </div>,
              attrs: {
                rowSpan: row.rowSpan1 || 0,
              },
            };
            return obj;
          },
        },
        {
          title: "车头", dataIndex: 'vehicle_number', align: 'center', scopedSlots: { customRender: 'vehicle_number' }, customRender: (value, row) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: row.rowSpan2 || 0,
              },
            };
            return obj;
          },
        },
        { title: "挂箱", dataIndex: 'vehicle_gnumber', align: 'center', scopedSlots: { customRender: 'vehicle_gnumber' } },
        { title: "线路", dataIndex: 'name', align: 'center', scopedSlots: { customRender: 'name' } },
        { title: "出发地", dataIndex: 'departure', align: 'center', scopedSlots: { customRender: 'departure' } },
        { title: "出发时间", dataIndex: 'time', align: 'center', scopedSlots: { customRender: 'time' } },
        { title: "目的地", dataIndex: 'destination', align: 'center', scopedSlots: { customRender: 'destination' } },
      ],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
  },
  activated() {

  },
  methods: {
    init(payload) {
      this.date = payload.date;
      this.getdata(payload);
    },
    getdata(payload) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/v2/result", payload).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.model = true;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

p {
  margin: 0;
}
</style>